// extracted by mini-css-extract-plugin
export default {"sideCard":"sideCard_sideCard__UyTdW"};